import { ReactElement } from "react"

import { GenericCreateCommentsComponent } from "./genericComments/genericCreateComment"
import { Datasets } from "../../constants/enums"
import useReadDeviceComment from "../../services/middleware/hooks/devices/common/useReadDeviceComments"

interface CreateCommentComponentProps {
    deviceSystemRef: string
    mutate: () => void
    isLoading: boolean
    createComment: (
        deviceSystemref: string,
        comment: string,
        dataset?: Datasets
    ) => Promise<void>
    dataset?: Datasets
    isThreadUnread?: boolean
    lastReadBy?: string
    lastReadAt?: string
    isV2gDevice?: boolean
}

/**
 * Component containing text field where user can add a comment to a device.
 */
export const CreateCommentComponent = ({
    deviceSystemRef,
    mutate,
    isLoading,
    createComment,
    dataset,
    isThreadUnread,
    lastReadBy,
    lastReadAt,
    isV2gDevice,
}: CreateCommentComponentProps): ReactElement => {
    const { toggleDeviceComment } = useReadDeviceComment(isV2gDevice)
    const addComment = (comment: string): Promise<void> =>
        createComment(deviceSystemRef, comment, dataset)

    const isApplication = !deviceSystemRef

    const toggleDeviceRead = (read: boolean): Promise<void> =>
        toggleDeviceComment(deviceSystemRef, read, dataset)

    return (
        <GenericCreateCommentsComponent
            isApplication={isApplication}
            mutate={mutate}
            isLoading={isLoading}
            createComment={addComment}
            toggleDeviceRead={toggleDeviceRead}
            isThreadUnread={isThreadUnread}
            lastReadAt={lastReadAt}
            lastReadBy={lastReadBy}
        />
    )
}

CreateCommentComponent.defaultProps = {
    dataset: null,
    isThreadUnread: false,
    lastReadBy: undefined,
    lastReadAt: undefined,
    isV2gDevice: false,
}
